<template>
    <div style="background:#F9FBFD">


        <jz-header :currentPage="'us'"></jz-header>
       <div class="about-page">
           <!-- 企业介绍 -->
           <div class="company-info container">
               <div class="title">企业介绍</div>
               <div class="info-block">
               <img src="https://jzmall.lifejingzhi.com/file/jz-gw/about/company.png"/>
               <div class="info-wrapper">
                <div class="paragraph">上海宅易丞鲸致网络科技有限公司成立于2018年，总部位于上海。</div>
                <div class="paragraph">公司目前服务已覆盖上海、深圳、北京、南京、苏州、杭州、青岛、广州、成都、重庆等170+城市，累计服务200万户+家庭用户。2023年，公司旗下子品牌“云嘉生活”上线，探索和拓展更多的业务形态以及垂类服务项目。公司深耕中高端家政服务生态，服务标准化、产品多元化，并致力践行“让家庭服务品质更高，让从业人员生活更美好”的使命。</div>
                <div class="paragraph">公司主营家政到家服务，业务含居家保洁、家电清洗、保姆、月嫂、钟点工、精细擦窗、除尘除螨、深度清洗、精品搬家等。六年来，凭借稳定的服务质量与良好的用户口碑，奠定了我们与各大机构坚实的合作基础；公司先后成为上海家政协会理事单位、上海家政协会副会长单位公司。</div>
                <div class="paragraph">展望未来，公司将继续着眼于全国市场的拓展，特别是针对高端生活服务领域的深化和创新。我们将坚持“全自培、专业化、标准化”的品牌基因，不断丰富和优化服务内容，提升服务标准，并持续探索创新的家庭生活服务方式。我们的目标是成为家庭服务领域的领军品牌，为客户带来卓越的生活体验，并推动整个行业向更高的服务品质和专业化标准迈进。</div>
               <div class="info-list">
                   <div class="info-item">
                       <div>总部位于</div>
                       <div class="info-data">上海</div>
                       <div>成立于2018年</div>
                   </div>
                   <div class="devide"></div>
                    <div class="info-item">
                       <div>目前覆盖</div>
                       <div class="info-data">170+城市</div>
                       <div>持续增加</div>
                   </div>
                   <div class="devide"></div>
                    <div class="info-item">
                       <div>累计服务</div>
                       <div class="info-data">200万户+</div>
                       <div>家庭用户</div>
                   </div>
               </div>
               </div>
               </div>
           </div>
           <!-- 企业文化 -->
           <div style="background:#fff">
           <div class="company-culture container">
               <div class="common-title">企业文化</div>
               <div class="culture-list">
                   <div class="culture-item">
                       <div class="culture-top">
                           <div class="culture-left">愿景</div>
                           <div class="culture-right"></div>
                       </div>
                       <div class="culture-line">共建家政行业健康生态</div>
                   </div>
                                   <div class="culture-item">
                       <div class="culture-top">
                           <div class="culture-left">使命</div>
                           <div class="culture-right2"></div>
                       </div>
                       <div class="culture-line">让家庭服务品质更高，让从业人员生活更美好</div>
                   </div>
               </div>

           </div>
           </div>
           <!-- 发展历程 -->
           <div class="development container">
               <div class="common-title">发展历程</div>
             <div class="develop-wrapper">
                    <el-carousel height="258px" :autoplay="false" indicator-position="none" @change="carouselChange" :interval="4000"  ref="carouse">
                 <el-carousel-item v-for="item in developList" :key="item.id">
        <div class="develop-item">
            <div class="item-bg">{{item.year}}</div>
            <div class="item-content">
            <div class="item-year"><span class="year">{{item.year}}</span> <span> 年</span></div>
            <div class="item-line">{{item.word1}}</div>
            <div class="item-line">{{item.word2}}</div>
            <div class="item-line">{{item.word3}}</div>
            <div class="item-line" v-if="item.word4">{{item.word4}}</div>
            </div>
        </div>
      </el-carousel-item>
                  </el-carousel>
             </div>
             <div class="year-list-wrapper">
                <div class="year-border">
                </div>
                <div class="year-list">
                <div class="year-block" v-for="(item,index) in developYearList" :key="item.id" @click="yearSwitch(item,index)">
                   <img :src="activeCal==index?'https://jzmall.lifejingzhi.com/file/jz-gw/about/icon-selected.png':'https://jzmall.lifejingzhi.com/file/jz-gw/about/icon-unselect.png'"/>
                   <div :class="[activeCal==index?'active-year':'']">{{item}}年</div>
                </div>
                </div>
             </div>

           </div>

           <!-- 合作机构 -->
           <div style="background:#fff;">
               <div class="cooperative-agency container">
                             <div class="common-title">合作机构</div>
                 <div class="tabs-block">
<el-tabs v-model="activeName" >
    <el-tab-pane label="银行合作" name="1">
        <div class="img-line">
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-pfyh.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-zsyh.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-payh.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-msyh.png"/>
        </div>
        <div class="coop-content">多平台合作露出，同时覆盖专业家庭生活的场景，作为奖励权益回馈达标客户，增加忠实客户粘性。</div>
        </el-tab-pane>
    <el-tab-pane label="集采项与买赠权益" name="2">
       <div class="img-line">
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-zgdx.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-zgsh.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-zabx.png"/>
        </div>
        <div class="coop-content">通过集采价格，提升集采优势，并减少购频次及供求沟通成本。</div>
    </el-tab-pane>
    <el-tab-pane label="物业模式" name="3">
          <div class="img-line">
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-wk.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-smjt.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-jdjt.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-gd.png"/>
        </div>
        <div class="coop-content">专属物业住户福利，通过优质的到家服务，提升住户对物业的信任度。</div>
    </el-tab-pane>
    <el-tab-pane label="互联网平台入驻" name="4">
           <div class="img-line">
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-kb.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-zfb.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-elm.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-gddt.png"/>
        </div>
        <div class="coop-content">通过入驻互联网平台，满足平台用户多维度家政需求，提升平台用户的活跃度及平台粘性。</div>
    </el-tab-pane>
    <el-tab-pane label="联营模式" name="5">
         <div class="img-line">
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-hm.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-qg.png"/>
        </div>
        <div class="coop-content">共同深化平台生活领域与鲸致生活的联营品牌，丰富平台优质客户的消费场景，提高客户满意度。</div>
    </el-tab-pane>
    <el-tab-pane label="集团员工福利" name="6">
          <div class="img-line">
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-bgjt.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-sqjt.png"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/company/logo-dk.png"/>
        </div>
        <div class="coop-content">通过员工福利的形式，服务有家政需求的员工，提升员工对企业的归属感。</div>
    </el-tab-pane>
  </el-tabs>
                 </div>
               </div>

           </div>
           <!-- 平台数据 -->
           <div class="platform container">
               <div class="common-title">平台数据</div>
               <div class="data-wrapper">
               <el-carousel height="260px" :interval="5000" :autoplay="true" indicator-position="outside" arrow="never">
      <el-carousel-item>
        <div class="data-item">
          <img src="https://jzmall.lifejingzhi.com/file/jz-gw/about/data-02.png"/>
          <div class="data-right">
              <div  class="data-title">
                  【爆款单品】 <br/>  &nbsp; 3小时日常居家保洁
              </div>
              <div class="data-content">
                  全网<span>1,459,922,519</span>播放量
              </div>
              <div class="tips">* 以上数据截止至2023年6月30日</div>
          </div>
        </div>
      </el-carousel-item>
         <el-carousel-item>
        <div class="data-item">
          <img src="https://jzmall.lifejingzhi.com/file/jz-gw/about/data-01.png"/>
          <div class="data-right">
              <div  class="data-title">
                  【品牌热词】 <br/>>#鲸致生活
              </div>
              <div class="data-content">
                  全网<span>3.4亿</span>次播放量
              </div>
              <div class="tips">* 以上数据截止至2023年10月07日</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    </div>
           </div>
           <!-- 培训学校 -->
           <div style="background:#fff;">
               <div class="container">
                  <div class="train-school">
                    <div class="title">
                        培训学校
                    </div>
                    <div class="content">我们现有上海易芸，南京狸想，昆山鲸致三所具备中华人民共和国民办办学学科的职业技能培训学校。学校开设：职业技能等级培训，家电清洗，整理收纳，鲸选钟点工四大类课程。<br/>
学校硬件设施完善，提供学员食宿，拥有雄厚的师资力量及先进的管理理念、科学的考评机制、严谨的教学作风与严格的淘汰率，学员只有通过考核后，才能被颁发鲸致证书，鲸致生活培训学校为社会培养了一批批优秀的家政服务人才。 </div>
         <div class="school-list">
   <img src="https://jzmall.lifejingzhi.com/file/jz-gw/about/school-01.png"/>
   <img src="https://jzmall.lifejingzhi.com/file/jz-gw/about/school-02.png"/>
   <img src="https://jzmall.lifejingzhi.com/file/jz-gw/about/school.png"/>
         </div>
                  </div>
               </div>
           </div>
           <div class="service-city container">
               <div class="title">服务覆盖城市</div>
   <img src="https://jzmall.lifejingzhi.com/file/jz-gw/about/map.png" class="map-img"/>
         <img src="https://jzmall.lifejingzhi.com/file/jz-gw/about/map-sea.png" class="map-sea"/>
           </div>


       </div>
        <jz-footer></jz-footer>
    </div>
</template>
<script>
import jzHeader from "@/components/common/Header";
import jzFooter from "@/components/common/Footer";
export default {
    data() {
        return {
           activeName:'1',
           activeCal:0,
           developYearList:['2018','2019','2020','2021','2022','2023'],
           developList:[
               {id:1,
                year:'2018',
                word1:'公司创立',
                word2:'上海开城',
                word3:'成为盒马唯一家政服务联营商'
               },
               {id:2,
                year:'2019',
                word1:'深圳 / 北京开城',
                word2:'保姆 / 月嫂 / 搬家新业务上线',
                word3:'成上海易芸培训学校成立',
                word4:'自建自培体系',
               },
                {id:3,
                year:'2020',
                word1:'成为上海家政协会理事单位',
                word2:'南京开城，南京狸想培训学校成立',
                word3:'口碑开启线上门店',
                word4:'开展与万科 / 金地等地产物业深度合作',
               },
                {id:4,
                year:'2021',
                word1:'鲸致生活小程序上线',
                word2:'苏州开城',
                word3:'开展与银行 / 移动运营商 / 国企等机构深度合作',
               },
                {id:5,
                year:'2022',
                word1:'打磨半年的自营钟点工正式上线',
                word2:'杭州、青岛、重庆、成都、广州开城',
                word3:'组织近千名保洁师参与上海抗疫一线 方舱支援',
                word4:'全面拓展合作渠道，共建网络服务',
               },
                {id:6,
                year:'2023',
                word1:'抖音本地生活上线',
                word2:'快手本地生活上线',
                word3:'“千城万店”项目启动，2个月覆盖80+城市',
                word4:'昆山培训运营基地启动，一站式培训+新型家庭服务业创业孵化',
               }

           ]
        }
    },
    methods:{
carouselChange(current,old){
    this.activeCal=current;
    // if(current==0){
    //     this.developYearList=['2018','2019','2020','2021','2022','2023'];
    // }else if(current==1){
    //      this.developYearList=['2019','2020','2021','2022','2023','2018'];
    // }else if(current==2){
    //      this.developYearList=['2020','2021','2022','2023','2018','2019'];
    // }else if(current==3){
    //      this.developYearList=['2021','2022','2023','2018','2019','2020'];
    // }else if(current==4){
    //      this.developYearList=['2022','2023','2018','2019','2020','2021'];
    // }else if(current==5){
    //      this.developYearList=['2023','2018','2019','2020','2021','2022'];
    // }
},
yearSwitch(item,index){
    console.log(item);
    setTimeout(()=>{
    // let index=0;
    // this.developYearList=['2018','2019','2020','2021','2022','2023'];
    // if(item=='2019'){
    //   index=1;
    //    this.developYearList=['2019','2020','2021','2022','2023','2018'];
    // }else if(item=='2020'){
    //   index=2;
    //     this.developYearList=['2020','2021','2022','2023','2018','2019'];
    // }else if(item=='2021'){
    //   index=3;
    //   this.developYearList=['2021','2022','2023','2018','2019','2020'];
    // }else if(item=='2022'){
    //   index=4;
    //   this.developYearList=['2022','2023','2018','2019','2020','2021'];
    // }else if(item=='2023'){
    //   index=5;
    //    this.developYearList=['2023','2018','2019','2020','2021','2022'];
    // }
    this.activeCal=index;
     this.$refs.carouse.setActiveItem(index);
    },200);

}
    },
    components:{
        jzHeader,
        jzFooter,
       }
}
</script>
<style  scoped>
.common-title{
  font-size: 30px;
     height: 30px;
     line-height: 30px;
     text-align: center;
}
 /* 企业介绍 */
 .company-info{
     padding:48px 0;
 }
.company-info .title{
  font-size: 30px;
     height: 30px;
     line-height: 30px;
     text-align: center;
     margin-bottom:28px;
}
.info-block{
    display: flex;
    justify-content: space-between;
}
.info-block img{
    width:230px;
    height:364px;
    margin-right:30px;
}
.info-wrapper .paragraph{
line-height: 26px;
margin-bottom:14px;
}
.info-list {
    display: flex;
    border-top:1px solid #D0D0D0;
    padding:20px 60px 0;
    height: 100px;
    justify-content: space-between;
}
.devide{
    width: 1px;
height: 80px;
background:  #D0D0D0;;
}
.info-item div{
    font-size: 12px;
    line-height: 22px;
}
.info-item div.info-data{
    color: #00BCFF;
    font-size: 26px;
    margin:8px 0;
}

 /* 企业文化 */
 .company-culture{
     height:306px;
     padding:48px 0;
 }
 .culture-list{
   display: flex;
   justify-content: space-between;
   margin-top:48px;
 }
 .culture-item{
     width:466px;
     height:130px;
     background: #F9FBFD;
     padding:28px 78px;
 }
 .culture-top{
     height: 26px;
     display: flex;
     justify-content: space-between;
     margin-bottom:28px;
 }
 .culture-left{
     font-size: 16px;
     height: 26px;
     line-height: 16px;
     padding-bottom:8px;
     border-bottom:2px solid #333;

 }
 .culture-right{
  width:26px;
  height:26px;
  background: url('https://jzmall.lifejingzhi.com/file/jz-gw/about/icon-hope.png') no-repeat center;
  background-size: 100%;
 }
  .culture-right2{
  width:26px;
  height:26px;
  background: url('https://jzmall.lifejingzhi.com/file/jz-gw/about/icon-task.png') no-repeat center;
  background-size: 100%;
 }
 .culture-line{
     height:14px;
     line-height: 14px;
 }
 .culture-item:hover{
     cursor: pointer;
     background: #00BCFF;
     color: #fff!important;
     transition: background 0.3s;
 }
 .culture-item:hover .culture-left{
 border-bottom:2px solid #fff;
 }
 .culture-item:hover .culture-right{
    background-image: url('https://jzmall.lifejingzhi.com/file/jz-gw/about/icon-hope-white.png')
}
.culture-item:hover .culture-right2{
    background-image: url('https://jzmall.lifejingzhi.com/file/jz-gw/about/icon-task-white.png')
}
 /* 发展历程 */
.development{
    height:454px;
    padding:52px 0 0;
}
.develop-wrapper{
    margin-top:30px;
}
.develop-item{
    height:228px;
    padding-left:140px;
    position: relative;
}
.item-bg{
    position: absolute;
    font-size: 160px;
    width: 370px;
height: 120px;
line-height: 120px;
font-weight: 600;
color: #F3F3F3;
left:320px;
top:30px;
}
.item-content{
    z-index:100;
    position: relative;
    padding:80px 0 0 20px;
}
.item-year{
    margin-bottom:20px;
    height:30px;
    line-height: 30px;
    display: flex;
    align-items: flex-end;
}
.item-year span.year{
    font-size: 30px;
    margin-right:2px;
}
.item-line{
    line-height: 28px;
}
.year-list-wrapper{
    height:40px;
    padding:0 40px;
    margin-top:10px;
}
.year-border{
    width: 900px;
height: 1px;
border: 1px solid #F1EFF0;
}
.year-list{
    display: flex;
    margin-top:-8px;
justify-content: space-around;
padding:0 60px;
}
>>> .develop-wrapper .el-carousel__arrow:hover{
   background:#00BCFF ;
}
.year-block{
    flex:1;
    text-align: center;
}
.year-block img{
    width:16px;
    height:16px;
}
.year-block:hover img{
    cursor: pointer;
}
.active-year{
    color: #00BCFF;
    font-size: 18px;
    transition: all 0.4s;
}
 /* 合作机构 */
.cooperative-agency{
    height:396px;
    padding-top:44px;
}
.tabs-block{
    margin-top:12px;
}
>>> .el-tabs__nav{
    margin-left:140px;
}
>>> .el-tabs__item{
    height:60px;
    padding:10px 24px;
}
>>> .el-tabs__item.is-active{
    color: #00BCFF;
}
>>> .el-tabs__active-bar{
    background: #00BCFF;
}
>>> .el-tabs__item:hover{
    color: #00BCFF;
}
.img-line{
    height:106px;
    margin:26px 0 42px;
    display: flex;
    justify-content: center;
}
.img-line img{
    width: 230px;
height: 116px;
background: #FFFFFF;
/* box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.08); */
margin-right:16px;
object-fit: contain;
}
.coop-content{
    font-size: 14px;
    text-align: center;
    height: 14px;
    line-height: 14px;
}
 /* 平台数据 */
.platform{
    height:444px;
    padding:52px 0 40px;
}
.data-wrapper{
    margin-top:50px;
}
.data-item{
    display: flex;
}
.data-item img{
    width:416px;
    height:240px;
    object-fit: contain;
    margin-right:48px;
}
.data-right{
  padding-top:24px;
}
.data-title{
   font-size: 20px;
   line-height: 38px;
   margin-bottom:48px;
}
.data-content{
    height: 28px;
    font-size: 14px;
    padding-left:10px;
}
.data-content  span{
    font-size: 28px;
    line-height: 30px;
    letter-spacing: 8px;
    font-weight: bold;
    margin:0 8px;
}
.data-item .tips{
    font-size: 14px;
    margin:32px 0 0 170px;
}
>>> .el-carousel__indicator.is-active button{
    background: #00BCFF!important;
}
>>> .el-carousel__button{
    width:50px;
}
 /* 培训学校 */
 .train-school{
     padding:48px 0 50px;
 }
 .train-school .title{
     font-size: 30px;
     height: 30px;
     line-height: 30px;
     margin-bottom:46px;
     text-align: center;
 }
  .train-school .content{
      line-height: 26px;
      margin-bottom:26px;
  }
  .school-list{
      display: flex;
      height: 182px;
      justify-content: space-between;
  }
  .school-list img{
      width:292px;
      height:182px;
  }
.service-city{
    height: 820px;
    position: relative;
    padding:50px 0;
}
.service-city .title{
    font-size: 30px;
    line-height:30px;
    height:30px;
    text-align: center;
}
.service-city .map-img{
    width:764px;
    height:642px;
    object-fit: contain;
    bottom:50px;
    left:38px;
    position:absolute;
}
.service-city .map-sea{
    width:160px;
    height:214px;
    object-fit: contain;
    bottom:50px;
    left:820px;
     position:absolute;
}

</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue